import {gql} from "@apollo/client";

export default gql`
  mutation addJobAnnouncement($data: JobAnnouncementInput!) {
    addJobAnnouncement(data: $data) {
      id
    }
  }
`;
